import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'Is this a physical book?',
  answer: 'No, this is a Digital Patriot Bundle. You get instant access to the Audiobook and PDF bonuses so you can start learning today.'
}, {
  question: 'How do I listen to the audiobook?',
  answer: 'You will receive high-quality MP3 files that play on any smartphone, tablet, or computer.'
}, {
  question: 'Is my payment secure?',
  answer: 'Absolutely. We use industry-standard encryption to ensure your data is 100% protected.'
}, {
  question: 'Can I share this with my family?',
  answer: 'Yes! In fact, we encourage you to listen to these tracks with your children or grandchildren.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-white py-16 px-4" data-id="element-74">
      <div className="max-w-3xl mx-auto" data-id="element-75">
        <h2 className="text-3xl font-bold text-center text-navy mb-10" data-id="element-76">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4" data-id="element-77">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-78">
              <button className="w-full px-6 py-4 text-left bg-gray-50 hover:bg-gray-100 flex justify-between items-center transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-79">
                <span className="font-bold text-navy" data-id="element-80">{faq.question}</span>
                <ChevronDown className={`text-gray-500 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={20} data-id="element-81" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 py-4 opacity-100' : 'max-h-0 py-0 opacity-0'}`} data-id="element-82">
                <p className="text-gray-600" data-id="element-83">{faq.answer}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}